export const localization = {
    pt: {
        title: 'Nenhum resultado encontrado',
        subtitle: 'Tente novamente com um termo diferente',
    },
    en: {
        title: 'No results found',
        subtitle: 'Try again with a different term',
    },
    es: {
        title: 'No se encontraron resultados',
        subtitle: 'Inténtalo de nuevo con un término diferente',
    },
  };
  